import { POST_DELETED_BY_ADMIN, POST_DELETED_BY_AUTHOR, POST_DELETED_BY_MODERATOR } from 'mk/autogenerated/translations/deleteable.03d8b2349f54f636d66ac965e4c1fca6'

export enum DeletedByRole {
    DeletedByAuthor = 0,
    DeletedByModerator = 1,
    DeletedByAdmin = 2,
}

export function postDeletedByToText(deletedByRole: DeletedByRole): string {
    switch (deletedByRole) {
        case DeletedByRole.DeletedByAdmin:
            return POST_DELETED_BY_ADMIN;
        case DeletedByRole.DeletedByModerator:
            return POST_DELETED_BY_MODERATOR;
        case DeletedByRole.DeletedByAuthor:
            return POST_DELETED_BY_AUTHOR;
    }
}
